import React from "react";
import { Select } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { IconCalendar } from "@tabler/icons-react";

import { getDateRanges } from "@data/dropdownValues";


interface DateRangeSelectProps {
  dateRange: string | null;
  setDateRange: React.Dispatch<React.SetStateAction<string | null>>;
  customDateRange: [Date | null, Date | null];
  setCustomDateRange: React.Dispatch<
    React.SetStateAction<[Date | null, Date | null]>
  >;
}
export const DateRangeSelect = ({
  dateRange,
  setDateRange,
  customDateRange,
  setCustomDateRange,
}: DateRangeSelectProps) => {
  return (
    <>
      <Select
        w={250}
        value={dateRange}
        onChange={setDateRange}
        data={getDateRanges()}
        comboboxProps={{ width: "fit-content", position: "bottom-start" }}
        allowDeselect={false}
      />
      {dateRange === "custom" && (
        <DatePickerInput
          type="range"
          placeholder="Select date range"
          leftSection={<IconCalendar size={16} stroke={1.5} />}
          value={customDateRange}
          onChange={setCustomDateRange}
          maxDate={new Date()}
        />
      )}
    </>
  );
};
